import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ParameterState {
  parameterToDelete: Parameter | null;
  setParameterToDelete: (newParameter: Partial<Parameter>) => void;
  resetParameterToDelete: () => void;
}

const initialParameterState: Parameter = {
  id: "",
  type: "",
  value: "",
  createdAt: new Date(),
  modifiedAt: new Date(),
};

export const useParameterDeleteStore = create<ParameterState>()(
  devtools(
    (set) => ({
      parameterToDelete: initialParameterState,
      setParameterToDelete: (newParameter) =>
        set((state) => ({
          parameterToDelete: { ...state.parameterToDelete, ...newParameter } as Parameter,
        })),
      resetParameterToDelete: () => set({ parameterToDelete: initialParameterState }),
    }),
    { name: "ParameterSelected" }
  )
);
